module.exports = __webpack_public_path__ + "static/media/elixir-packaging-img-1.b1fc61f2.jpg";